import * as React from 'react';
import { Grid, ColSpan, createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
    root: {
        paddingBottom: 0,
        maxWidth: '100% !important',
        [theme.fn.smallerThan('sm')]: {
            // paddingBottom: '2rem'
        }
    }
}));

interface GridColProps {
    children: React.ReactNode;
    lg?: ColSpan;
    md?: ColSpan;
    span?: ColSpan;
}

export const GridCol: React.FC<GridColProps> = ({ children, ...props }) => {
    const { classes } = useStyles();

    return (
        <Grid.Col className={classes.root} {...props}>
            {children}
        </Grid.Col>
    );
};
